export default {
  navigation: {
    title: "Paramètres",
    subtitle: "Configurez votre espace GenIaC"
  },
  quickActions: {
    title: "Actions rapides",
    viewUsage: "Voir l'utilisation",
    manageSubs: "Gérer l'abonnement",
    viewInvoices: "Voir les factures"
  },
  search: {
    placeholder: "Rechercher dans les paramètres..."
  },
  menu: {
    connections: {
      label: "Service connexion",
      description: "Gérez vos connexions aux fournisseurs cloud"
    },
    users: {
      label: "Utilisateurs",
      description: "Gestion des utilisateurs et synchronisation"
    },
    teams: {
      label: "Équipes",
      description: "Gérez vos équipes de travail"
    },
    groups: {
      label: "Groupes",
      description: "Organisez vos utilisateurs en équipes"
    },
    permissions: {
      label: "Permissions",
      description: "Configurez les rôles et leurs accès"
    },
    devops: {
      label: "Service DevOps",
      description: "Intégrations CI/CD et pipelines"
    },
    subscription: {
      label: "Abonnement",
      description: "Gérez votre abonnement et facturation"
    },
    usage: {
      label: "Utilisation & Quotas",
      description: "Suivez votre utilisation et gérez vos quotas"
    },
    byoo: {
      label: "BYOO Azure DevOps",
      description: "Votre propre organisation Azure DevOps"
    },
    whiteLabel: {
      label: "White Label",
      description: "Personnalisez avec votre marque"
    },
    paymentMethods: {
      label: "Moyens de paiement",
      description: "Gérez vos cartes bancaires"
    },
    invoices: {
      label: "Factures",
      description: "Consultez et téléchargez vos factures"
    },
    gdpr: {
      label: "Données & Confidentialité",
      description: "Gérez vos données personnelles (RGPD)"
    },
    admin: {
      label: "Dashboard Admin",
      description: "Métriques, abonnements et revenus"
    }
  },
  welcome: {
    title: "Bienvenue dans les Paramètres",
    connections: {
      title: "Service connexion",
      description: "Configurez vos connexions Azure, AWS et GCP"
    },
    users: {
      title: "Utilisateurs",
      description: "Gérez les accès et synchronisez vos annuaires"
    },
    teams: {
      title: "Équipes",
      description: "Organisez vos équipes de travail"
    },
    devops: {
      title: "Service DevOps",
      description: "Intégrez vos pipelines CI/CD"
    },
    subscription: {
      title: "Abonnement",
      description: "Gérez votre plan et facturation"
    },
    usage: {
      title: "Utilisation & Quotas",
      description: "Suivez votre consommation et gérez vos quotas"
    },
    paymentMethods: {
      title: "Moyens de paiement",
      description: "Gérez vos cartes bancaires et méthodes de paiement"
    },
    invoices: {
      title: "Factures",
      description: "Consultez et téléchargez vos factures"
    },
    admin: {
      title: "Dashboard Admin",
      description: "Métriques, abonnements et revenus de la plateforme"
    }
  },
  connections: {
    header: {
      title: "Services de connexion",
      subtitle: "Configurez vos connexions aux fournisseurs cloud"
    },
    buttons: {
      newConnection: "Nouvelle connexion",
      addConnection: "Ajouter une connexion"
    },
    empty: {
      title: "Aucune connexion",
      subtitle: "Ajoutez votre première connexion cloud"
    },
    providers: {
      azure: "Microsoft Azure",
      aws: "Amazon Web Services",
      gcp: "Google Cloud Platform"
    },
    types: {
      servicePrincipal: "Service Principal",
      managedIdentity: "Managed Identity",
      oauth: "OAuth 2.0",
      sshKey: "SSH Key",
      apiKey: "API Key"
    },
    status: {
      connected: "Connecté",
      failed: "Échec",
      testing: "Test..."
    },
    labels: {
      status: "Statut",
      lastTested: "Dernier test",
      subscriptionId: "Subscription ID"
    },
    menu: {
      test: "Tester la connexion",
      edit: "Modifier",
      delete: "Supprimer"
    },
    time: {
      justNow: "À l'instant",
      minutesAgo: "Il y a {{count}} min",
      hoursAgo: "Il y a {{count}}h",
      daysAgo: "Il y a {{count}}j"
    },
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette connexion ?",
    modal: {
      titleEdit: "Modifier la connexion",
      titleNew: "Nouvelle connexion",
      nameLabel: "Nom de la connexion *",
      namePlaceholder: "Ex: Azure Production",
      providerLabel: "Fournisseur cloud *",
      typeLabel: "Type de connexion",
      azureTitle: "Informations Azure",
      awsTitle: "Informations AWS",
      gcpTitle: "Informations GCP",
      tenantId: "Tenant ID",
      clientId: "Client ID",
      clientSecret: "Client Secret",
      subscriptionId: "Subscription ID",
      accessKeyId: "Access Key ID",
      secretAccessKey: "Secret Access Key",
      region: "Région",
      projectId: "Project ID",
      serviceAccountKey: "Service Account Key (JSON)",
      cancel: "Annuler",
      save: "Enregistrer",
      create: "Créer la connexion",
      nameRequired: "Le nom de la connexion est requis"
    }
  },
  users: {
    header: {
      title: "Utilisateurs",
      subtitle: "Gérez les utilisateurs et synchronisez avec vos fournisseurs d'identité"
    },
    buttons: {
      sync: "Synchroniser",
      newUser: "Nouvel utilisateur"
    },
    search: {
      placeholder: "Rechercher un utilisateur..."
    },
    table: {
      user: "Utilisateur",
      role: "Rôle",
      provider: "Fournisseur",
      groups: "Groupes",
      actions: "Actions"
    },
    roles: {
      Admin: "Admin",
      Developer: "Developer",
      Viewer: "Viewer"
    },
    providers: {
      Local: "Local",
      "Azure AD": "Azure AD",
      "AWS IAM": "AWS IAM",
      "GCP IAM": "GCP IAM"
    },
    menu: {
      edit: "Modifier",
      delete: "Supprimer"
    },
    deleteConfirm: "Supprimer cet utilisateur ?",
    modal: {
      titleEdit: "Modifier utilisateur",
      titleNew: "Nouvel utilisateur",
      fullName: "Nom complet",
      email: "Email",
      role: "Rôle",
      provider: "Fournisseur",
      cancel: "Annuler",
      save: "Enregistrer"
    },
    syncModal: {
      title: "Synchroniser les utilisateurs",
      providerLabel: "Fournisseur d'identité",
      info: "Les utilisateurs seront importés depuis {{provider}} avec leurs rôles et groupes.",
      cancel: "Annuler",
      sync: "Synchroniser",
      syncing: "Synchronisation...",
      successAlert: "Synchronisation {{provider}} terminée - {{count}} utilisateurs importés"
    }
  },
  groups: {
    header: {
      title: "Groupes",
      subtitle: "Organisez vos utilisateurs en équipes avec des permissions héritées"
    },
    buttons: {
      newGroup: "Nouveau groupe"
    },
    card: {
      members: "{{count}} membres"
    },
    menu: {
      edit: "Modifier",
      delete: "Supprimer"
    },
    deleteConfirm: "Supprimer le groupe \"{{name}}\" ?",
    modal: {
      titleEdit: "Modifier groupe",
      titleNew: "Nouveau groupe",
      groupName: "Nom du groupe",
      description: "Description",
      permissions: "Permissions",
      cancel: "Annuler",
      save: "Enregistrer"
    },
    demo: {
      administrators: {
        name: "Administrators",
        description: "Administrateurs système avec tous les droits"
      },
      developers: {
        name: "Developers",
        description: "Équipe de développement"
      },
      viewers: {
        name: "Viewers",
        description: "Accès en lecture seule"
      }
    }
  },
  permissions: {
    header: {
      title: "Permissions",
      subtitle: "Gérez les rôles et leurs permissions sur les projets"
    },
    buttons: {
      newRole: "Nouveau rôle"
    },
    card: {
      users: "{{count}} utilisateurs"
    },
    menu: {
      edit: "Modifier",
      delete: "Supprimer"
    },
    deleteConfirm: "Supprimer le rôle \"{{name}}\" ?",
    modal: {
      titleEdit: "Modifier rôle",
      titleNew: "Nouveau rôle",
      roleName: "Nom du rôle",
      description: "Description",
      permissions: "Permissions",
      permissionLabels: {
        read: "Lecture",
        write: "Écriture",
        delete: "Suppression",
        deploy: "Déploiement",
        manage_projects: "Gérer projets",
        manage_users: "Gérer utilisateurs",
        admin: "Administration complète"
      },
      cancel: "Annuler",
      save: "Enregistrer"
    },
    demo: {
      admin: {
        name: "Admin",
        description: "Accès complet à toutes les fonctionnalités"
      },
      developer: {
        name: "Developer",
        description: "Accès développement et déploiement"
      },
      viewer: {
        name: "Viewer",
        description: "Accès en lecture seule"
      }
    }
  },
  devops: {
    header: {
      title: "DevOps",
      subtitle: "Configurez votre organisation Azure DevOps pour la gestion des repositories et pipelines"
    },
    success: {
      title: "Connexion réussie",
      subtitle: "Organisation configurée et accessible"
    },
    scenarios: {
      existing: {
        title: "Organisation existante",
        description: "Connecter à une organisation Azure DevOps existante",
        icon: "🔗"
      },
      create: {
        title: "Créer une organisation",
        description: "Créer une nouvelle organisation dédiée",
        icon: "➕"
      },
      shared: {
        title: "Organisation partagée",
        description: "Utiliser une organisation partagée avec un projet dédié",
        icon: "👥"
      }
    },
    configTitle: {
      existing: "existante",
      create: "nouvelle",
      shared: "partagée"
    },
    fields: {
      orgUrl: "URL de l'organisation *",
      orgUrlPlaceholder: "https://dev.azure.com/votre-organisation",
      orgUrlHint: "(ex: https://dev.azure.com/votre-org)",
      pat: "Personal Access Token (PAT) *",
      patPlaceholder: "••••••••••••••••",
      patHint: "Le PAT doit avoir les permissions: Code (Read & Write), Build (Read & Execute)",
      orgName: "Nom de l'organisation *",
      orgNamePlaceholder: "mon-organisation",
      orgNameUrlHint: "L'URL sera: https://dev.azure.com/{{orgName}}",
      projectName: "Nom du projet dédié *",
      projectNamePlaceholder: "GenIaC-Project"
    },
    info: {
      title: "Information importante",
      createMessage: "Une nouvelle organisation Azure DevOps sera créée automatiquement lors de la sauvegarde. Vous devrez être authentifié avec un compte Microsoft."
    },
    buttons: {
      test: "Tester la connexion",
      testing: "Test en cours...",
      save: "Enregistrer"
    },
    help: {
      title: "Comment obtenir un Personal Access Token ?",
      step1: "Allez sur Azure DevOps → User Settings → Personal Access Tokens",
      step2: "Cliquez sur \"New Token\"",
      step3: "Donnez un nom et sélectionnez les scopes: Code (Read & Write), Build (Read & Execute)",
      step4: "Copiez le token généré et collez-le ci-dessus"
    },
    alert: {
      saved: "Configuration DevOps enregistrée"
    }
  },
  subscription: {
    header: {
      title: "Abonnement",
      subtitle: "Gérez votre abonnement et facturation"
    },
    billingCycle: {
      monthly: "Mensuel",
      yearly: "Annuel",
      discount: "-17%",
      monthShort: "mois",
      yearShort: "an",
      savings: "Économisez {{amount}}€ /an"
    },
    badges: {
      popular: "Populaire",
      current: "Actuel"
    },
    viewUsageLink: "Voir mon utilisation et mes quotas →",
    buttons: {
      choosePlan: "Choisir ce plan",
      currentPlan: "Plan actuel",
      contactUs: "Nous contacter"
    },
    price: {
      free: "Gratuit",
      contactUs: "Nous contacter",
      perMonth: "/mois",
      perYear: "/an",
      yearlyDiscount: "ou {{amount}}€/an (-20%)"
    },
    limits: {
      title: "LIMITES",
      projects: "Projets",
      architectures: "Architectures",
      deploymentsPerMonth: "Déploiements/mois",
      unlimited: "Illimités",
      unlimitedFem: "Illimitées"
    },
    paymentMethod: {
      title: "Moyen de paiement",
      noCardRequired: "Aucune carte bancaire requise pour le plan gratuit",
      upgradeHint: "Passez à un plan payant pour ajouter votre moyen de paiement",
      manageDescription: "Gérez vos méthodes de paiement et consultez vos factures via le portail Stripe sécurisé",
      manageButton: "Gérer mon abonnement"
    },
    billingHistory: {
      title: "Historique de facturation",
      noInvoices: "Aucune facture disponible",
      status: {
        paid: "Payé",
        open: "En attente",
        draft: "Brouillon",
        void: "Annulé",
        uncollectible: "Impayé"
      }
    },
    plans: {
      free: {
        name: "Gratuit",
        features: [
          "5 projets maximum",
          "10 ressources par projet",
          "Support communautaire",
          "Terraform export basique",
          "Stockage 1GB"
        ]
      },
      standard: {
        name: "Standard",
        features: [
          "3 projets",
          "50 architectures",
          "30 déploiements/mois",
          "Support email",
          "Export Terraform",
          "Intégration Azure DevOps",
          "Stockage 10GB",
          "Historique 90 jours"
        ]
      },
      entreprise: {
        name: "Entreprise",
        features: [
          "Projets illimités",
          "Architectures illimitées",
          "Déploiements illimités",
          "Support prioritaire + SLA",
          "Auto-provisioning DevOps",
          "SSO / SAML",
          "Audit logs",
          "Stockage illimité",
          "Historique 365 jours"
        ]
      },
      pro: {
        name: "Pro",
        features: [
          "Projets illimités",
          "Ressources illimitées",
          "Support prioritaire 24/7",
          "Backup automatique quotidien",
          "Terraform avancé + modules",
          "Intégration CI/CD",
          "Stockage 50GB",
          "Multi-cloud (Azure, AWS, GCP)",
          "Historique 90 jours"
        ]
      },
      enterprise: {
        name: "Enterprise",
        features: [
          "Tout Pro +",
          "SSO / SAML",
          "Audit logs complets",
          "Support dédié + CSM",
          "SLA 99.9%",
          "Environnements isolés",
          "Compliance & sécurité",
          "Stockage illimité",
          "Historique illimité",
          "Formation personnalisée"
        ]
      }
    },
    features: {
      projects: "{{count}} projets",
      architectures: "{{count}} architectures",
      deployments: "{{count}} déploiements/mois",
      unlimitedProjects: "Projets illimités",
      unlimitedArchitectures: "Architectures illimitées",
      unlimitedDeployments: "Déploiements illimités",
      azureDevOps: "Auto-provisioning Azure DevOps",
      prioritySupport: "Support prioritaire"
    },
    checkout: {
      title: "Choisissez votre plan",
      subtitle: "Sélectionnez le plan qui correspond le mieux à vos besoins",
      currentPlan: "Plan actuel",
      recommended: "Recommandé",
      free: "Gratuit",
      perMonth: "mois",
      perYear: "an",
      saveAmount: "Économisez {{amount}}€ par an ({{percentage}}% de réduction)",
      billingCycle: {
        monthly: "Mensuel",
        yearly: "Annuel (économisez 20%)"
      },
      buttons: {
        cancel: "Annuler",
        proceed: "Procéder au paiement",
        processing: "Traitement..."
      },
      errors: {
        samePlan: "Vous êtes déjà sur ce plan",
        cannotDowngradeToFree: "Veuillez contacter le support pour passer au plan Gratuit",
        generic: "Une erreur s'est produite. Veuillez réessayer."
      },
      securityNotice: "Paiement sécurisé par Stripe. Vos informations de paiement sont cryptées et sécurisées."
    },
    paymentModal: {
      title: "Confirmer l'abonnement",
      subtitle: "Vous êtes sur le point de souscrire au plan:",
      cardNumber: "Numéro de carte",
      cardNumberPlaceholder: "1234 5678 9012 3456",
      expiration: "Expiration",
      expirationPlaceholder: "MM/AA",
      cvv: "CVV",
      cvvPlaceholder: "123",
      cancel: "Annuler",
      confirm: "Confirmer",
      alert: "Abonnement au plan {{planName}} confirmé !"
    }
  },
  teams: {
    header: {
      title: "Équipes",
      subtitle: "Gérez vos équipes de travail et leurs membres"
    },
    buttons: {
      newTeam: "Nouvelle équipe",
      createFirstTeam: "Créer votre première équipe",
      viewDetails: "Voir les détails"
    },
    empty: {
      title: "Aucune équipe",
      subtitle: "Créez votre première équipe pour mieux organiser votre travail"
    },
    demo: {
      infrastructure: {
        name: "Infrastructure",
        description: "Équipe en charge de l'infrastructure cloud"
      },
      security: {
        name: "Sécurité",
        description: "Équipe responsable de la sécurité et de la conformité"
      },
      application: {
        name: "Application",
        description: "Équipe de développement applicatif"
      }
    },
    card: {
      members: "Membres",
      projects: "Projets",
      projectsList: "Projets assignés",
      teamLeads: "Responsables",
      more: "autres"
    },
    menu: {
      manageMembers: "Gérer les membres",
      edit: "Modifier",
      delete: "Supprimer"
    },
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer l'équipe {{name}} ?",
    modal: {
      titleEdit: "Modifier l'équipe",
      titleNew: "Nouvelle équipe",
      teamName: "Nom de l'équipe",
      teamNamePlaceholder: "Ex: Infrastructure Cloud",
      description: "Description",
      descriptionPlaceholder: "Décrivez le rôle de cette équipe...",
      color: "Couleur",
      cancel: "Annuler",
      save: "Enregistrer",
      create: "Créer l'équipe",
      nameRequired: "Le nom de l'équipe est requis"
    },
    membersModal: {
      subtitle: "{{count}} membre(s)",
      addMember: "Ajouter un membre",
      memberName: "Nom complet",
      memberEmail: "Email",
      memberRole: "Rôle",
      roles: {
        member: "Membre",
        teamLead: "Responsable d'équipe"
      },
      cancel: "Annuler",
      add: "Ajouter",
      close: "Fermer",
      noMembers: "Aucun membre dans cette équipe"
    }
  },
  invoices: {
    header: {
      title: "Factures",
      subtitle: "Consultez et téléchargez l'historique de vos factures"
    },
    refresh: "Actualiser",
    loading: "Chargement des factures...",
    empty: {
      title: "Aucune facture",
      description: "Vous n'avez pas encore de factures. Elles apparaîtront ici après votre premier paiement."
    },
    error: {
      title: "Erreur de chargement",
      retry: "Réessayer"
    },
    stats: {
      totalBilled: "Total facturé",
      pending: "En attente",
      paidCount: "Factures payées",
      totalInvoices: "Total factures"
    },
    filters: {
      search: "Rechercher par numéro...",
      allStatuses: "Tous les statuts",
      paid: "Payées",
      open: "En attente",
      void: "Annulées",
      uncollectible: "Impayées",
      allDates: "Toutes les dates",
      lastMonth: "Dernier mois",
      last3Months: "3 derniers mois",
      thisYear: "Cette année",
      clearFilters: "Effacer les filtres",
      resultsCount: "{{count}} facture(s) trouvée(s)",
      statusLabel: "Statut",
      periodLabel: "Période",
      searchLabel: "Recherche"
    },
    noResults: {
      title: "Aucun résultat",
      description: "Aucune facture ne correspond à vos critères de recherche.",
      resetFilters: "Réinitialiser les filtres"
    },
    table: {
      date: "Date",
      number: "Numéro",
      status: "Statut",
      amount: "Montant",
      actions: "Actions"
    },
    status: {
      paid: "Payée",
      open: "En attente",
      void: "Annulée",
      uncollectible: "Impayée",
      draft: "Brouillon"
    },
    actions: {
      view: "Voir",
      viewOnline: "Voir la facture en ligne",
      downloadPdf: "Télécharger le PDF"
    },
    footer: {
      showing: "Affichage de {{filtered}} sur {{total}} facture(s)",
      totalDisplayed: "Total affiché"
    },
    info: {
      title: "À propos des factures",
      autoGenerated: "Les factures sont générées automatiquement à chaque renouvellement de votre abonnement",
      emailSent: "Vous recevez également un email avec la facture à l'adresse de facturation",
      pdfAvailable: "Les PDF sont conservés et accessibles à tout moment depuis cette page",
      contact: "Pour toute question sur une facture, contactez"
    }
  },
  paymentMethods: {
    header: {
      title: "Méthodes de paiement",
      subtitle: "Gérez vos cartes bancaires pour les paiements récurrents"
    },
    addCard: "Ajouter une nouvelle carte",
    savedCards: "Cartes enregistrées",
    loading: "Chargement...",
    empty: {
      title: "Aucune méthode de paiement",
      description: "Ajoutez une carte bancaire pour pouvoir souscrire à un abonnement payant.",
      cta: "Ajouter ma première carte"
    },
    card: {
      expires: "Expire le",
      expired: "Expirée",
      default: "Par défaut",
      setDefault: "Définir par défaut",
      delete: "Supprimer"
    },
    brands: {
      visa: "Visa",
      mastercard: "Mastercard",
      amex: "American Express",
      unknown: "Carte"
    },
    addModal: {
      title: "Ajouter une carte bancaire",
      cardDetails: "Informations de la carte",
      cancel: "Annuler",
      add: "Ajouter la carte",
      adding: "Ajout en cours...",
      securePayment: "Paiement sécurisé par Stripe"
    },
    deleteModal: {
      title: "Supprimer la carte",
      message: "Êtes-vous sûr de vouloir supprimer cette carte ?",
      cardInfo: "{{brand}} se terminant par {{last4}}",
      warning: "Cette action est irréversible.",
      cancel: "Annuler",
      delete: "Supprimer",
      deleting: "Suppression..."
    },
    toast: {
      addSuccess: "Carte ajoutée avec succès",
      addError: "Erreur lors de l'ajout de la carte",
      deleteSuccess: "Carte supprimée avec succès",
      deleteError: "Erreur lors de la suppression",
      setDefaultSuccess: "Carte définie par défaut",
      setDefaultError: "Erreur lors de la modification",
      loadError: "Erreur lors du chargement des moyens de paiement"
    },
    info: {
      title: "Informations",
      secureStorage: "Vos informations de paiement sont stockées de manière sécurisée par Stripe",
      defaultCard: "La carte par défaut sera utilisée pour les renouvellements automatiques",
      multipleCards: "Vous pouvez ajouter plusieurs cartes et changer celle par défaut à tout moment"
    }
  },
  cancellation: {
    title: "Annuler l'abonnement",
    steps: {
      reason: "Raison",
      offers: "Offres",
      feedback: "Feedback",
      confirm: "Confirmation"
    },
    reasonStep: {
      title: "Nous sommes tristes de vous voir partir",
      subtitle: "Pourriez-vous nous dire pourquoi vous souhaitez annuler ?",
      reasons: {
        too_expensive: "Trop cher pour mon budget",
        not_using_enough: "Je n'utilise pas assez le service",
        missing_features: "Fonctionnalités manquantes",
        switching_competitor: "Je passe à un concurrent",
        temporary_pause: "Pause temporaire du projet",
        company_closing: "Fermeture de l'entreprise",
        other: "Autre raison"
      }
    },
    offersStep: {
      title: "Avant de partir...",
      subtitle: "Nous avons des offres spéciales pour vous !",
      applying: "Application...",
      discount: {
        title: "{{percent}}% de réduction",
        description: "Bénéficiez de {{percent}}% de réduction sur votre prochain mois d'abonnement.",
        accept: "Accepter l'offre"
      },
      pause: {
        title: "Mettre en pause {{days}} jours",
        description: "Mettez votre abonnement en pause pendant {{days}} jours sans perdre vos données ni configurations.",
        accept: "Mettre en pause"
      },
      downgrade: {
        title: "Passer au plan Standard",
        description: "Gardez accès à GenIaC avec un plan moins coûteux au lieu d'annuler complètement.",
        accept: "Changer de plan"
      },
      notInterested: "Ces offres ne vous intéressent pas ?",
      continueCancel: "Continuer l'annulation"
    },
    feedbackStep: {
      title: "Aidez-nous à nous améliorer",
      subtitle: "Votre feedback est précieux pour nous (optionnel)",
      selectedReason: "Raison sélectionnée",
      additionalComments: "Commentaires additionnels",
      placeholder: "Partagez vos suggestions ou ce que nous aurions pu faire différemment...",
      reminder: {
        title: "Rappel important",
        message: "Votre abonnement restera actif jusqu'au {{date}}. Après cette date, vous passerez automatiquement au plan gratuit."
      }
    },
    confirmStep: {
      title: "Confirmer l'annulation",
      subtitle: "Cette action est définitive",
      summary: {
        currentPlan: "Plan actuel",
        reason: "Raison",
        endDate: "Fin d'accès"
      },
      consequences: {
        title: "Ce qui va se passer :",
        cancelAtEnd: "Votre abonnement sera annulé à la fin de la période",
        switchToFree: "Vous passerez au plan gratuit avec ses limitations",
        projectsArchived: "Vos projets au-delà des quotas seront archivés",
        canResubscribe: "Vous pourrez vous réabonner à tout moment"
      }
    },
    buttons: {
      back: "Retour",
      cancel: "Annuler",
      continue: "Continuer",
      confirm: "Confirmer l'annulation",
      cancelling: "Annulation..."
    }
  },
  usage: {
    header: {
      title: "Utilisation & Quotas",
      subtitle: "Suivez votre consommation et gérez vos quotas"
    },
    currentPlan: "Plan actuel",
    billingPeriod: "Période de facturation",
    resources: {
      projects: "Projets",
      architectures: "Architectures",
      deployments: "Déploiements ce mois",
      storage: "Stockage",
      users: "Utilisateurs",
      pipelineMinutes: "Minutes CI/CD"
    },
    usage: {
      used: "utilisé(s)",
      of: "sur",
      unlimited: "illimité"
    },
    alerts: {
      approaching: "Vous approchez de la limite",
      exceeded: "Limite dépassée",
      upgrade: "Passez au plan supérieur pour plus de capacité",
      limitReached: "Limite atteinte",
      critical: "Critique",
      warning: "Attention",
      moderate: "Modéré",
      ok: "OK"
    },
    upgrade: {
      title: "Besoin de plus ?",
      description: "Passez au plan supérieur pour débloquer plus de ressources",
      button: "Voir les plans"
    },
    overview: "Vue d'ensemble",
    remaining: "restant",
    remainingPlural: "restants",
    usedPercent: "{{percent}}% utilisé",
    resetsAt: "Réinit. {{date}}",
    thisMonth: "Ce mois-ci",
    history: {
      title: "Historique d'utilisation",
      days7: "7 jours",
      days30: "30 jours",
      days90: "90 jours",
      pipelineTitle: "Minutes CI/CD consommées"
    },
    trial: {
      active: "Période d'essai active",
      expiringSoon: "Période d'essai bientôt expirée",
      expired: "Période d'essai expirée",
      expiredMessage: "Votre période d'essai gratuite a expiré. Passez à un plan payant pour continuer à utiliser GenIaC.",
      daysRemaining: "{{days}} sur votre période d'essai gratuite.",
      choosePlan: "Choisir un plan",
      upgradeNow: "Mettre à niveau maintenant"
    },
    noData: "Aucune donnée d'abonnement disponible",
    refresh: "Actualiser",
    upgradeButton: "Mettre à niveau",
    loading: "Chargement...",
    error: {
      title: "Erreur de chargement",
      retry: "Réessayer"
    },
    upgradeSuggestion: {
      title: "Passez au plan {{plan}}",
      button: "Voir les plans"
    }
  },
  byoo: {
    header: {
      title: "BYOO Azure DevOps",
      subtitle: "Bring Your Own Organization - Utilisez votre propre organisation Azure DevOps"
    },
    loading: "Chargement...",
    infoBanner: {
      title: "Fonctionnalité réservée au plan BUSINESS",
      description: "Configurez votre propre organisation Azure DevOps pour un contrôle total sur vos projets. Vous aurez besoin d'un Personal Access Token (PAT) avec les permissions:",
      permissions: "Project and Team (Read, Write, & Manage)"
    },
    status: {
      validated: "Configuration validée",
      notValidated: "Configuration non validée",
      organization: "Organisation",
      lastValidated: "Dernière validation"
    },
    errors: {
      businessOnly: "Cette fonctionnalité est disponible uniquement pour le plan BUSINESS.",
      loadFailed: "Erreur lors du chargement de la configuration",
      required: "URL de l'organisation et Personal Access Token sont requis",
      saveFailed: "Erreur lors de la configuration",
      testFailed: "Erreur lors du test de connexion",
      deleteFailed: "Erreur lors de la suppression"
    },
    success: {
      title: "Succès",
      testSuccess: "{{message}} - {{count}} projets trouvés"
    },
    error: {
      title: "Erreur"
    },
    config: {
      title: "Configuration",
      subtitleNew: "Configurer votre organisation Azure DevOps",
      subtitleEdit: "Mettre à jour votre configuration BYOO"
    },
    form: {
      orgUrl: "URL de l'organisation Azure DevOps *",
      orgUrlPlaceholder: "https://dev.azure.com/YourOrganization",
      orgUrlHint: "Format: https://dev.azure.com/YourOrganization",
      pat: "Personal Access Token (PAT) *",
      patPlaceholder: "Entrer votre PAT",
      patPlaceholderKeep: "Laisser vide pour conserver le PAT actuel",
      patHint: "Le PAT doit avoir les permissions:",
      patCurrent: "PAT actuel",
      namingPattern: "Pattern de nommage des projets",
      namingPatternHint: "Variables disponibles: {orgSlug}, {projectName}, {userId}, {date}",
      subscriptionId: "ID de Subscription Azure (optionnel)",
      defaultLocation: "Région Azure par défaut"
    },
    buttons: {
      test: "Tester",
      testing: "Test...",
      save: "Enregistrer",
      update: "Mettre à jour",
      saving: "Enregistrement...",
      delete: "Supprimer",
      deleting: "Suppression..."
    },
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer la configuration BYOO ? Cette action est irréversible.",
    help: {
      title: "Comment créer un Personal Access Token ?",
      steps: [
        "Allez sur dev.azure.com",
        "Cliquez sur votre avatar > User Settings > Personal Access Tokens",
        "Cliquez sur \"New Token\"",
        "Donnez un nom au token et sélectionnez votre organisation",
        "Définissez la durée de validité (recommandé: 90 jours ou plus)",
        "Dans les Scopes, sélectionnez: Project and Team (Read, Write, & Manage)",
        "Cliquez sur \"Create\" et copiez le token généré",
        "Collez le token dans le champ ci-dessus"
      ]
    }
  },
  whiteLabel: {
    header: {
      title: "White Label",
      subtitle: "Personnalisez l'interface avec votre marque"
    },
    loading: "Chargement...",
    infoBanner: {
      title: "Fonctionnalité réservée au plan BUSINESS",
      description: "Personnalisez l'apparence de GenIaC avec votre logo, vos couleurs et vos textes. Les modifications seront visibles pour tous les utilisateurs de votre organisation."
    },
    status: {
      active: "White Label actif",
      inactive: "White Label désactivé",
      lastModified: "Dernière modification"
    },
    errors: {
      businessOnly: "Cette fonctionnalité est disponible uniquement pour le plan BUSINESS.",
      loadFailed: "Erreur lors du chargement de la configuration",
      invalidPrimaryColor: "Couleur primaire invalide. Format requis: #RRGGBB",
      invalidSecondaryColor: "Couleur secondaire invalide. Format requis: #RRGGBB",
      invalidAccentColor: "Couleur d'accent invalide. Format requis: #RRGGBB",
      saveFailed: "Erreur lors de la configuration",
      resetFailed: "Erreur lors de la réinitialisation",
      deleteFailed: "Erreur lors de la suppression"
    },
    success: {
      title: "Succès"
    },
    error: {
      title: "Erreur"
    },
    config: {
      title: "Configuration",
      subtitle: "Personnalisez l'apparence de votre plateforme"
    },
    branding: {
      title: "Branding",
      appName: "Nom de l'application",
      companyName: "Nom de votre entreprise",
      companyNamePlaceholder: "Ma Société",
      logoUrl: "URL du logo",
      logoUrlPlaceholder: "https://example.com/logo.png ou data:image/png;base64,...",
      logoUrlHint: "URL publique ou data URL (base64)",
      faviconUrl: "URL du favicon",
      faviconUrlPlaceholder: "https://example.com/favicon.ico"
    },
    colors: {
      title: "Couleurs",
      primary: "Couleur primaire",
      secondary: "Couleur secondaire",
      accent: "Couleur d'accent"
    },
    content: {
      title: "Contenu",
      welcomeMessage: "Message de bienvenue",
      welcomeMessagePlaceholder: "Bienvenue sur notre plateforme IaC personnalisée",
      footerText: "Texte du footer",
      footerTextPlaceholder: "© 2026 Ma Société - Tous droits réservés",
      supportEmail: "Email de support",
      supportEmailPlaceholder: "support@masociete.com",
      supportUrl: "URL de support",
      supportUrlPlaceholder: "https://support.masociete.com"
    },
    advanced: {
      title: "Avancé",
      customDomain: "Domaine personnalisé",
      customDomainPlaceholder: "iac.masociete.com",
      customDomainHint: "Nécessite une configuration DNS",
      hideBranding: "Masquer la mention \"Powered by GenIaC\""
    },
    buttons: {
      save: "Enregistrer",
      saving: "Enregistrement...",
      reset: "Réinitialiser",
      resetting: "Réinitialisation...",
      disable: "Désactiver",
      disabling: "Suppression..."
    },
    confirmReset: "Êtes-vous sûr de vouloir réinitialiser la configuration aux valeurs par défaut ?",
    confirmDelete: "Êtes-vous sûr de vouloir désactiver la configuration White Label ? Cette action est réversible.",
    preview: {
      title: "Aperçu des couleurs",
      primary: "Primaire",
      secondary: "Secondaire",
      accent: "Accent"
    }
  },
  gdpr: {
    title: "Données & Confidentialité (RGPD)",
    subtitle: "Gérez vos données personnelles et exercez vos droits RGPD",
    exportTitle: "Exporter mes données",
    exportDescription: "Téléchargez une copie complète de toutes vos données stockées dans GenIaC au format JSON (Article 20 RGPD - Droit à la portabilité).",
    dataIncluded: {
      personalInfo: "Informations personnelles et de contact",
      organization: "Détails de l'organisation",
      subscriptions: "Abonnements et historique de facturation",
      projects: "Projets et configurations",
      architectures: "Architectures cloud",
      deployments: "Historique des déploiements",
      invoices: "Factures et paiements",
      usage: "Métriques d'utilisation et statistiques"
    },
    exportButton: "Télécharger mes données",
    exporting: "Préparation de l'export...",
    exportSuccess: "Vos données ont été téléchargées avec succès !",
    exportError: "Erreur lors de l'export des données. Veuillez réessayer plus tard.",
    deleteTitle: "Supprimer mon compte",
    deleteDescription: "Supprimez définitivement votre compte et toutes les données associées (Article 17 RGPD - Droit à l'oubli).",
    deleteWarningTitle: "Cette action est irréversible !",
    deleteWarning: "Une fois confirmé, votre compte et toutes vos données seront définitivement supprimés. Vous recevrez un email de confirmation avec un lien sécurisé pour finaliser la suppression.",
    deletionEffects: {
      projects: "Tous vos projets et architectures seront supprimés",
      architectures: "Toutes les configurations d'infrastructure seront supprimées",
      subscriptions: "Votre abonnement actif sera annulé",
      invoices: "Les factures seront anonymisées (conservation légale 7 ans)"
    },
    deleteButton: "Supprimer mon compte",
    processing: "Traitement en cours...",
    deleteEmailSent: "Un email de confirmation a été envoyé. Consultez votre boîte de réception et cliquez sur le lien pour confirmer la suppression dans les 24 heures.",
    deletionError: "Erreur lors de la demande de suppression du compte. Veuillez réessayer plus tard.",
    confirmDeleteTitle: "Confirmer la suppression du compte",
    confirmDeleteMessage: "Êtes-vous absolument sûr de vouloir supprimer votre compte ? Cette action est irréversible. Vous recevrez un email de confirmation.",
    confirmDelete: "Oui, supprimer mon compte",
    cancel: "Annuler"
  }
};
